export class ImpactAssessmentT4ColumnModel {
    id: boolean;
    regulator: boolean;
    title: boolean;
    ruleTopic: boolean;
    publishDate!: boolean;
    ruleType: boolean;
    applicationDate: boolean;
    lastUpdate: boolean;
    jurisdiction: boolean;
    assessor: boolean;
    assessmentStatus: boolean;

  
    constructor() {
      this.id = true;
      this.regulator = true;
      this.title = true;
      this.ruleTopic = true;
      this.ruleType = true;
      this.applicationDate = true;
      this.lastUpdate = true;
      this.jurisdiction = true;
      this.assessor = true;
      this.assessmentStatus = true;
    }
  }
  